import {
    Form,
    FormField,
    FormSection,
    FormType,
    InputType,
} from '@fitogest/reactive-form-builder/interfaces';
import {
    ReactiveDomainSectionFactory,
    ReactiveListModalDefinitionFactory,
    ReactiveModalFormState,
    type ReactiveModalFormStateSnapshot,
    ReactiveModalMaterialLineFactory,
    ReactiveModalReadonlyFieldFactory,
} from '@fitogest/reactive-form-builder/utils';
import { AlbaranModel } from 'src/app/models/ventas/albaran.model';

export class AlbaranesListModalFormDefinition {
  public readonly formFields: Form<AlbaranModel>;
  public readonly model: Partial<AlbaranModel>;
  public readonly modalState: ReactiveModalFormStateSnapshot<AlbaranModel>;

  constructor(type: FormType, model: Partial<AlbaranModel>, context: unknown = {}) {
    const form = ReactiveListModalDefinitionFactory.create<AlbaranModel>({
      name: 'albaranes-list-modal',
      header: 'Datos del albarán',
      type,
      sections: this.getSections(),
    });

    this.modalState = ReactiveModalFormState.create<AlbaranModel>({ type, model, form, context });
    this.model = this.modalState.model;
    this.formFields = this.modalState.form;
  }

  private getSections(): FormSection<AlbaranModel>[] {
    return [
      ReactiveDomainSectionFactory.identificacion<AlbaranModel>({
        name: 'Datos del albarán',
        fields: this.getIdentificationFields(),
        order: 1,
      }),
      ReactiveDomainSectionFactory.datosAdministrativos<AlbaranModel>({
        name: 'Materiales',
        fields: this.getMaterialFields(),
        order: 2,
      }),
      ReactiveDomainSectionFactory.observaciones<AlbaranModel>({
        name: 'Datos adicionales',
        fields: this.getAdditionalFields(),
        order: 3,
      }),
    ];
  }

  private getIdentificationFields(): FormField<AlbaranModel>[] {
    return ReactiveModalReadonlyFieldFactory.createMany<AlbaranModel>([
      { name: 'albaran_id', label: 'Nº Referencia', order: 1, width: 3 },
      { name: 'chofer_nombre', label: 'Chofer', order: 2, width: 3 },
      { name: 'fecha', label: 'Fecha', order: 3, width: 3 },
      { name: 'direccion', label: 'Dirección', order: 4, width: 3 },
      { name: 'cif', label: 'CIF', order: 5, width: 3 },
      { name: 'cliente_nombre', label: 'Cliente', order: 6, width: 3 },
      { name: 'poblacion', label: 'Población', order: 7, width: 3 },
      { name: 'cp', label: 'Código Postal', order: 8, width: 3 },
      { name: 'telefono', label: 'Teléfono', order: 9, width: 3 },
      { name: 'correo', label: 'Correo', order: 10, width: 3 },
      { name: 'obra_nombre', label: 'Obra', order: 11, width: 3 },
    ]);
  }

  private getMaterialFields(): FormField<AlbaranModel>[] {
    return ReactiveModalMaterialLineFactory.createFields<AlbaranModel>();
  }

  private getAdditionalFields(): FormField<AlbaranModel>[] {
    return ReactiveModalReadonlyFieldFactory.createMany<AlbaranModel>([
      { name: 'trabajos_realizados', label: 'Trabajos realizados', order: 1, width: 6, type: InputType.TEXTAREA },
      { name: 'conforme', label: 'Conforme', order: 2, width: 6, type: InputType.TEXTAREA },
    ]);
  }

}
